import { useState } from "react";

/** Create an organisation.
 *
 *  A NAME, and optionally a note about who they are. That is all.
 *
 *  Nothing here grants access: allocating a product is a separate act, on the
 *  organisation's own page. An organisation with no allocation is simply one
 *  nobody has given anything to yet — it can still be named, referred to and
 *  listed, and it costs nothing.
 *
 *  An earlier draft asked for party roles and who pays for access. Both are
 *  later concerns, and neither is something you know at the moment you are
 *  typing a company's name.
 */
export function OrganisationForm({ onCancel, onDone }: {
  onCancel: () => void;
  onDone: (name: string) => void;
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [err, setErr] = useState("");

  function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return setErr("A name is required.");
    setErr("");
    // Fixtures stand in for the endpoint; the call site does not change when
    // POST /modules/organisations lands.
    onDone(name.trim());
  }

  return (
    <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
        <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <span className="cap">Organisation name</span>
          <input className="search" value={name} autoFocus style={{ marginLeft: 0, width: 280 }}
            placeholder="Nexcell Pack Works" onChange={(e) => setName(e.target.value)} />
        </label>
        <label style={{ display: "flex", flexDirection: "column", gap: 4, flexGrow: 1 }}>
          <span className="cap">Description (optional)</span>
          <input className="search" value={description} style={{ marginLeft: 0, width: "100%", minWidth: 220 }}
            placeholder="Pack manufacturing and repair" onChange={(e) => setDescription(e.target.value)} />
        </label>
      </div>

      {err && <div style={{ fontSize: 12.5, color: "var(--bad)" }}>{err}</div>}

      <div style={{ display: "flex", gap: 8 }}>
        <button type="submit" className="btn teal sm">Create organisation</button>
        <button type="button" className="btn ghost sm" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
}
